import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  THEME_DARK,
  LEVEL_OF_PROTECTION_DIALOG,
  SWE_LIMIT_DIALOG,
} from "common/src/helpers/constants";
import { useApolloClient } from "@apollo/client";
import {
  QUERY_GET_LIMITS,
  QUERY_GET_TIMEOUT,
} from "common/src/graphql/queries";
import { printAmount } from "common/src/helpers/functions";
import { Redirect, useHistory } from "react-router-dom";
import DepositDialog from "common/src/component/DepositDialog";
// import { WithdrawAlertDialog } from "../modal/WithdrawAlertDialog";
import { LevelOfProtectionDialog } from "common/src/modal/LevelOfProtectionDialog";
import { ProfileNotCompleteDialog } from "common/src/modal/ProfileNotCompleteDialog";
import { SetLimitsDialog } from "common/src/modal/SetLimitsDialog";
// import { destroySession } from "common/src/helpers/session.js";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import IFrame from "common/src/component/IFrame";
import DepositStepNewWindow from "common/src/component/DepositStepNewWindow";
import config from "../config.json";
import { PageContent } from "common/src/styledComponents/AccountPage";
import {
  CloseIframeWrapper,
  DepositAndWithdrawalRow,
  DepositWithdrawalList,
  DepositWithdrawalText,
  DepositWithdrawalWrapper,
  FrameBox,
  PageheadlinePar,
} from "common/src/styledComponents/StyledDepositAndWithdrawal";
import { FullPageOverlay } from "common/src/styledComponents/StyledGame";
/* import { NewsButtonWrapper } from "common/src/styledComponents/StyledNews"; */
import { StyledButton } from "common/src/styledComponents/CommonStyledComponents";
/* import { checkSWEDepositLimit } from "common/src/helpers/checkSWEDepositLimit"; */
// import { KYCDialog } from "common/src/modal/KYCDialog";
// import { toast } from "react-toastify";
import { isSafari } from "react-device-detect";
import { PaymentServer } from "common/src/helpers/connectors";
import { NewsButtonWrapper } from "common/src/styledComponents/StyledNews";

let selectedDeposit = "";
let cancelDepositFlag = true;

const Deposit = ({
  currentTheme,
  server,
  bannedDepositPage,
  hasWithdraw,
  player,
  riskyCountry,
  preselectedDeposit,
  setSpinner,
  isMobile,
  isTablet,
  userAgent,
  inGame,
  closeIngame,
  depositList,
  setShowWithdrawAlertDialog,
  setSweLimitDialog,
  //setNlLimitDialog,
  pages,
  titles,
  setPxDepositStart,
  firstDeposit,
}) => {
  const apolloClient = useApolloClient();
  const location = useLocation();
  const history = useHistory();
  let selectedBonusCode = "";
  if (typeof location.state !== "undefined") {
    selectedBonusCode = location.state.bonusCode;
  }
  // console.log("bonus code " + JSON.stringify(selectedBonusCode));
  const { t, i18n } = useTranslation("");
  // const baseUrl = "/" + i18n.language;
  const { country, zipCode, isVerified } = player;
  const [step, setStep] = useState(0);
  const [depositStepIFrame, setDepositStepIframe] = useState("");
  const [depositStepFormAction, setDepositStepFormAction] = useState("");
  const [depositStepIFrameParameters, setDepositStepIframeParameters] =
    useState({});
  const [depositStepIFrameMethod, setDepositStepIframeMethod] = useState("");
  const [depositStepIFrameWidth, setDepositStepIframeWidth] = useState("600");
  const [depositStepIFrameHeight, setDepositStepIframeHeight] = useState("600");
  const [depositStepIFrameSrcDoc, setDepositStepIframeSrcDoc] = useState(null);
  const [pendingDepositID, setPendingDepositID] = useState("");
  const isSE = country === "se" ? true : false;

  const showList = useCallback(
    (doCancel) => {
      const cancelDeposit = () => {
        if (pendingDepositID !== "" && cancelDepositFlag) {
          console.log("---- cancel deposit: " + pendingDepositID + " -------");
          //first one is payment provider, second one transaction id
          let paramsArray = pendingDepositID.split(",");
          if (paramsArray.length === 2) {
            PaymentServer.delete(
              "/fhnd/v1/transaction/deposit/" +
                paramsArray[0] +
                "/" +
                paramsArray[1]
            )
              .then((/*res*/) => {
                console.log("---- deposit canceled ----");
                return true;
              })
              .catch((error) => {
                console.log("---- deposit cancel failed ----");
                return false;
              });
          }
        }
        //this is when cancel deposit button is pressed on dresponse success/pending page - reload deposit page to update balance (not sure if socket will update balance)
        if (!cancelDepositFlag) window.location.reload();
      };

      setStep(0);
      selectedDeposit = "";

      //cancel pending deposit on iframe close
      doCancel && cancelDeposit();
    },
    [pendingDepositID]
  );

  useEffect(() => {
    const handler = (event) => {
      // console.log("FRAME EVENT: " + JSON.stringify(event));
      // console.log(typeof event.data)
      // console.log("origin" + event.origin)
      // console.log("origin 2: " + window.location.origin)
      if (event.origin === window.location.origin) {
        // console.log("same origin!");
        let data = null;
        if (typeof event.data !== "undefined") {
          try {
            data = JSON.parse(event.data);
          } catch (e) {
            data = event.data;
          }
          // console.log("DATA: " + JSON.stringify(event.data))
          if (
            typeof data.cancelDeposit !== "undefined" &&
            data.cancelDeposit === "off"
          ) {
            console.log("set cancel deposit flag to false");
            cancelDepositFlag = false;
          }
          if (typeof data.list !== "undefined" && data.list) {
            console.log("set deposit step list!");
            showList(true);
          }
        }
      }
    };

    window.addEventListener("message", handler);

    // clean up
    return () => window.removeEventListener("message", handler);
  }, [setStep, showList]); // empty array => run only once

  useEffect(() => {
    const scrollToTop = () => {
      if (step === 2 || step === 5) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    };
    scrollToTop();
  }, [step]);

  useEffect(() => {
    // console.log(titles)
    if (!inGame) {
      document.title = titles["deposit"];
    }
  }, [titles, inGame]);

  useEffect(() => {
    if (isSafari && typeof config.piqApplepay !== "undefined") {
      const script = document.createElement("script");

      script.src = config.piqApplepay;
      script.async = true;

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  useEffect(() => {
    //if payment is piq card, load their script

    const script = document.createElement("script");

    script.src = config.piqEncripter;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (typeof preselectedDeposit !== "undefined" && preselectedDeposit !== "") {
    //show deposit step automatically if prop is set
    selectedDeposit = preselectedDeposit;
    setStep(1);
  }
  const [showProfileNotCompliteDialog, setShowProfileNotCompliteDialog] =
    useState(false);
  const [showLevelOfProtectionDialog, setShowLevelOfProtectionDialog] =
    useState(false);
  const [showSetLimitsDialog, setShowSetLimitsDialog] = useState(false);
  const [hasTimeout, setHasTimeout] = useState(false);
  const [supportRedirect, setSupportRedirect] = useState(false);
  const [registerAdditionalStepRedirect, setRegisterAdditionalStepRedirect] =
    useState(false);
  // const redirectTo = "index";
  // const [gameRedirect, setGameRedirect] = useState(false);
  /*   const [isUK, setIsUK] = useState(false);
  const [isSE, setIsSE] = useState(false);

  useEffect(() => {
    if (country === "gb") setIsUK(true);
    if (country === "se") setIsSE(true);
  }, [country]); */

  useEffect(() => {
    // console.log("deposit skin: " + config.skin);
    // console.log("deposit cookie: " + Cookies.get("activated"));
    // console.log(isVerified);
    if (
      config.skin === "plc" &&
      typeof isVerified !== "undefined" &&
      !isVerified
    ) {
      // console.log("redirect after activation");
      Cookies.set("activated", "activated", { secure: true });
      setRegisterAdditionalStepRedirect(true);
      // window.location.replace(pages["register"]);
    }
  }, [isVerified]);

  useEffect(() => {
    // console.log("deposit skin: " + config.skin);
    // console.log("deposit cookie: " + Cookies.get("activated"));
    if (config.skin === "plc" && Cookies.get("activated")) {
      // console.log("redirect after activation");
      setRegisterAdditionalStepRedirect(true);
      // window.location.replace(pages["register"]);
    }
  }, [pages]);

  useEffect(() => {
    // if(!isVerified && firstDeposit) {
    //   //
    //   return;
    // }
    if (bannedDepositPage) {
      if (!riskyCountry) {
        sessionStorage.setItem("user_banned_from_page", true);
      } else {
        sessionStorage.setItem("user_from_risky_country", true);
      }
      // window.location = `${baseUrl}/support`;
      setSupportRedirect(true);
    }
  }, [bannedDepositPage, riskyCountry, isVerified, firstDeposit]);

  useEffect(() => {
    if (country === "gb" && zipCode === "") {
      setShowProfileNotCompliteDialog(true);
    }
    if (sessionStorage.getItem("show-limits-reseted") === "true") {
      setShowSetLimitsDialog(true);
      sessionStorage.setItem("show-limits-reseted", false);
    }
    //don't exist anymore set on activate uk player
    if (country === "gb" && Cookies.get("uk_player_set_limits") === true) {
      setShowSetLimitsDialog(true);
    }

    // if (hasWithdraw && country !== "gb" && country !== "se") {
    //   setShowWithdrawAlertDialog(true);
    // }

    if (localStorage.getItem(SWE_LIMIT_DIALOG)) {
      setSweLimitDialog(true);
    }
    /* if (
      localStorage.getItem(NL_LIMIT_DIALOG) &&
      localStorage.getItem("bonuses-available") === "hidden" &&
      localStorage.getItem("bonuses-available") === "temp_hidden"
    ) {
      setNlLimitDialog(true);
    } */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    country,
    zipCode,
    hasWithdraw,
    setSweLimitDialog,
    // setShowWithdrawAlertDialog,
  ]);

  useEffect(() => {
    async function getLimits() {
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_LIMITS,
      });
      if (loading) return <h3>Loading ...</h3>;
      if (errors) return false;
      return data.getLimits.limits;
    }

    function checkSWEDepositLimit() {
      // console.log("check is set limit for swe");
      let hasTimelimitDaily = false;
      let hasTimelimitWeekly = false;
      let hasTimelimitMonthly = false;
      let hasDepositLimit = false;
      getLimits().then((limits) => {
        limits &&
          limits.forEach((limit) => {
            if (limit.limit === "deposit") {
              hasDepositLimit = true;
            }
            if (
              limit.limitType === "daily_timelimit" &&
              limit.initialAmount > 0
            ) {
              hasTimelimitDaily = true;
            }
            if (
              limit.limitType === "monthly_timelimit" &&
              limit.initialAmount > 0
            ) {
              hasTimelimitMonthly = true;
            }
            if (
              limit.limitType === "weekly_timelimit" &&
              limit.initialAmount > 0
            ) {
              hasTimelimitWeekly = true;
            }
            // console.log(hasDepositLimit + " " + hasTimelimitDaily + " " + hasTimelimitMonthly + " " + hasTimelimitWeekly)
          });
        if (
          !hasDepositLimit /* ||
            !hasTimelimitDaily ||
            !hasTimelimitWeekly ||
            !hasTimelimitMonthly */
        ) {
          // console.log("should redirect!");
          localStorage.setItem("sweSetDepositLimit", "show");
          // window.location = `${baseUrl}/my-limits`;
          history.push({ pathname: pages["my-limits"], tab: 1 });
        }
      });
    }
    if (country === "se") {
      checkSWEDepositLimit();
    }
  }, [country, apolloClient, history, pages]);

  useEffect(() => {
    if (
      sessionStorage.getItem("scrollToLobby") &&
      config.skin === "pub" &&
      config.skin === "cac" &&
      config.skin === "hyc" &&
      config.skin === "plc"
    ) {
      document.getElementById("scroll-to-category-onlogin").scrollIntoView();
      sessionStorage.removeItem("scrollToLobby");
    } else {
      window.scrollTo({
        top: 0,
      });
    }
  }, []);

  // const { loading, error, data } = useQuery(QUERY_ME_DEPOSITS);
  // if (loading) return <div></div>;
  // //if there is an error on ME call, player is not logged in, redirect to logout to delete session token
  // if (error) {
  //   destroySession();
  //   return <Redirect to={baseUrl + "/index"}></Redirect>;
  // }
  const startDeposit = (depositType /*paymentProvider*/) => {
    // console.log("start deposit: " + hasWithdraw)
    //check if its available deposit type for player
    window.scrollTo({
      top: 0,
    });
    if (
      config.skin !== "plc" ||
      !firstDeposit ||
      depositType.indexOf("iDEAL PIQ") >= 0 ||
      depositType.indexOf("iDeal TR") >= 0
    ) {
      // if (!hasWithdraw || player.country === "gb" || player.country === "se") {
      selectedDeposit = depositType;
      console.log("set cancel deposit flag to true");
      cancelDepositFlag = true;
      if (player.country !== "se" || player.nationalID !== "") {
        checkLevelOfProtection();
      }
      // setSpinner(true);
      // }
    } else {
      console.log("first deposit must be ideal");
    }
  };

  const checkLevelOfProtection = () => {
    //disabled on Jans request
    // if (
    //   country === "gb" &&
    //   localStorage.getItem(LEVEL_OF_PROTECTION_DIALOG) !== "accepted"
    // ) {
    //   // setSpinner(false);
    //   setShowLevelOfProtectionDialog(true);
    // } else {
    setSpinner(true);
    getTimeout();
    // }
  };

  async function getTimeout() {
    const { loading, data, errors } = await apolloClient.query({
      query: QUERY_GET_TIMEOUT,
    });

    if (loading) return <h3>Loading ...</h3>;
    if (errors) {
      if (errors[0].message === "error_timeout_not_exist") {
        setHasTimeout(false);
      } else {
        console.log(errors);
      }
    }

    //setTimeout(data.getTimeout);
    // console.log("timeout: " + JSON.stringify(data))
    if (data.getTimeout !== null) {
      setSpinner(false);
      setHasTimeout(true);
    } else {
      showDepositDialog();
    }
  }

  const showDepositDialog = () => {
    setStep(1);
    setSpinner(false);
  };

  // let depositBlock = data.me.lockStatus.deposit;
  // let playerCountry = data.me.player.country;
  // console.log(player.currency)
  //if deposits are blocked redirect to support page, display popup
  // if (depositBlock) {
  //   //TODO: display popup
  //   return <Redirect to={baseUrl + "/support"}></Redirect>;
  // }

  const confirmLevelOfProtection = () => {
    localStorage.setItem(LEVEL_OF_PROTECTION_DIALOG, "accepted");
    setShowLevelOfProtectionDialog(false);
    getTimeout();
  };

  const cancelLevelOfProtection = () => {
    setShowLevelOfProtectionDialog(false);
    // window.location = `${baseUrl}/support`;
    setSupportRedirect(true);
  };

  if (step === 3) {
    console.log("redirect to games: " + inGame);
    if (inGame) {
      closeIngame();
    } else {
      window.location.replace(pages["index"]);
      // setGameRedirect(true);
      // return <Redirect to={pages["games"]}></Redirect>;
    }
  }

  if (registerAdditionalStepRedirect) {
    return <Redirect to={pages["register"]}></Redirect>;
  }

  if (supportRedirect) {
    return <Redirect to={pages["support"]}></Redirect>;
  }

  if (hasTimeout) {
    sessionStorage.setItem("TIMEOUT_ACTIVE_FLAG", true);
    // window.location = `${baseUrl}/support`;
    setSupportRedirect(true);
  }

  // if (gameRedirect) {
  //   return <Redirect to={pages["games"]}></Redirect>;
  // }

  // console.log(server.cdn + "plc/payments-v2/nl/")

  return (
    <>
      <PageContent bg dep ingamedep={inGame}>
        {step === 0 && (
          <DepositWithdrawalWrapper ingamedep={inGame}>
            {/*  <PageheadlinePar as="div" dep>
              <h3>{t("label_please_select_deposit")}</h3>
            </PageheadlinePar> */}
            <DepositWithdrawalList ingamedep={inGame}>
              {depositList.map((deposit) => {
                // console.log("deposit: " + JSON.stringify(deposit));
                if (
                  (!deposit.isTesting || player.isTesting) &&
                  (deposit.depositType !== "ApplePay PIQ" || isSafari)
                ) {
                  let minAmount = printAmount(
                    deposit.minimum,
                    player.currency,
                    server.currencies,
                    true
                  );
                  return (
                    <DepositAndWithdrawalRow
                      testing={player.isTesting && deposit.isTesting}
                      key={deposit.depositType}
                    >
                      {deposit.depositImage && deposit.depositImageDark && (
                        <img
                          // id="visa"
                          className="col1"
                          alt={deposit.depositType}
                          height="100%"
                          srcSet={
                            currentTheme === THEME_DARK
                              ? server.cdn +
                                config.paymentsImagePath +
                                "/" +
                                deposit.depositImage
                              : server.cdn +
                                config.paymentsImagePath +
                                "/" +
                                deposit.depositImageDark
                          }
                        />
                      )}
                      {!inGame && (
                        <p className="col2">
                          {t("label_transaction_time")}:{" "}
                          {t(deposit.transactionTime)}
                        </p>
                      )}{" "}
                      {inGame && (
                        <p className="col2">
                          {deposit.depositType
                            .replace("PIQ", "")
                            .replace("PIQ-EPRO", "")
                            .replace("PIQ-NS", "")
                            .replace("PIQ-TSI", "")
                            .replace("PIQ-CRX", "")
                            .replace("PIQ-ET", "")
                            .replace("PIQ-BANK", "")
                            .replace("PIQ-ADYEN", "")}
                        </p>
                      )}
                      {!inGame && (
                        <p className="col3">
                          {t("label_service_fee")}: {t(deposit.transactionFee)}
                        </p>
                      )}{" "}
                      {!inGame && (
                        <p className="col4">
                          {t("label_minimum_amount")}: {minAmount}
                        </p>
                      )}
                      <button
                        data-name={deposit.depositType}
                        data-provider={deposit.paymentProvider}
                        className={
                          config.skin !== "plc" ||
                          !firstDeposit ||
                          deposit.depositType.indexOf("iDEAL PIQ") >= 0 ||
                          deposit.depositType.indexOf("iDeal TR") >= 0
                            ? "col5 btn btn-first btn-deposit-dialog"
                            : "col5 btn btn-first btn-deposit-dialog unavailable"
                        }
                        alt=""
                        height="100%"
                        onClick={() =>
                          startDeposit(
                            deposit.depositType /*deposit.paymentProvider*/
                          )
                        }
                      >
                        {t("label_deposit")}
                      </button>{" "}
                    </DepositAndWithdrawalRow>
                  );
                }
                return <span key={deposit.depositType}></span>;
              })}
              <style></style>
              <br />
              {!inGame && (
                <DepositWithdrawalText
                  dangerouslySetInnerHTML={{ __html: t("label_deposit_text") }}
                ></DepositWithdrawalText>
              )}
              {/*{!inGame && (*/}
              {/*  <div className="show-games-wrapper">*/}
              {/*    <Link to={pages['games']} className="btn btn-second button-show-games">*/}
              {/*      {t('label_show_games', 'label_show_games')}*/}
              {/*    </Link>*/}
              {/*  </div>*/}
              {/*)}*/}
            </DepositWithdrawalList>
            {!inGame && (
              <NewsButtonWrapper>
                <StyledButton
                  btn
                  type="button"
                  onClick={() => history.push(pages["index"])}
                >
                  {t("label_play")}
                </StyledButton>
              </NewsButtonWrapper>
            )}
          </DepositWithdrawalWrapper>
        )}
        {step === 1 && (
          <DepositWithdrawalWrapper ingamedep={inGame}>
            {/*  <PageheadlinePar dep>
              <h3>{t("label_please_fill_in_deposit_information")}</h3>
            </PageheadlinePar> */}
            {depositList.map((deposit) => {
              // console.log(selectedDeposit)
              if (selectedDeposit === deposit.depositType) {
                return (
                  <DepositDialog
                    serverSetup={server}
                    depositType={deposit}
                    playerData={player}
                    backAction={showList}
                    currentTheme={currentTheme}
                    key={deposit.depositType}
                    setSpinner={setSpinner}
                    isMobile={isMobile}
                    isTablet={isTablet}
                    userAgent={userAgent}
                    setDepositStepIframe={setDepositStepIframe}
                    setDepositStepFormAction={setDepositStepFormAction}
                    setDepositStep={setStep}
                    bonusCode={selectedBonusCode}
                    selectedImage={
                      currentTheme === THEME_DARK
                        ? server.cdn +
                          config.paymentsImagePath +
                          (config.skin === "fun" ||
                          config.skin === "cac" ||
                          config.skin === "hyc"
                            ? "/"
                            : "/" + i18n.language + "/") +
                          deposit.depositImage
                        : server.cdn +
                          config.paymentsImagePath +
                          (config.skin === "fun" ||
                          config.skin === "cac" ||
                          config.skin === "hyc"
                            ? "/"
                            : "/" + i18n.language + "/") +
                          deposit.depositImageDark
                    }
                    inGame={inGame}
                    pages={pages}
                    setDepositStepIframeParameters={
                      setDepositStepIframeParameters
                    }
                    setDepositStepIframeMethod={setDepositStepIframeMethod}
                    setDepositStepIframeWidth={setDepositStepIframeWidth}
                    setDepositStepIframeHeight={setDepositStepIframeHeight}
                    setDepositStepIframeSrcDoc={setDepositStepIframeSrcDoc}
                    setPxDepositStart={setPxDepositStart}
                    description={deposit.description}
                    // piqEncripter={config.piqEncripter}
                    skin={config.skin}
                    setPendingDepositID={setPendingDepositID}
                    showFirstDepositSelect={firstDeposit && !isSE}
                  />
                );
              }
              return <span key={deposit.depositType}></span>;
            })}
          </DepositWithdrawalWrapper>
        )}
        {step === 2 &&
          (depositStepIFrame !== "" || depositStepIFrameSrcDoc !== "") && (
            <FullPageOverlay>
              <FrameBox>
                {!selectedDeposit.toLowerCase().includes("trustly") &&
                  !selectedDeposit.toLowerCase().includes("paysafe") && (
                    <CloseIframeWrapper>
                      <StyledButton
                        searchbutton
                        mainsearch
                        onClick={() => {
                          setSpinner(true);
                          setStep(0);
                          selectedDeposit = "";
                          setTimeout(() => {
                            showList(true);
                            setSpinner(false);
                          }, 3000);
                        }}
                      ></StyledButton>
                    </CloseIframeWrapper>
                  )}
                <IFrame
                  src={depositStepIFrame}
                  className="pnp-iframe"
                  width={depositStepIFrameWidth}
                  height={depositStepIFrameHeight}
                  setDepositStep={setStep}
                  requestMethod={depositStepIFrameMethod}
                  requestParams={depositStepIFrameParameters}
                  srcDoc={depositStepIFrameSrcDoc}
                />
              </FrameBox>
            </FullPageOverlay>
          )}
        {step === 5 && (
          <FullPageOverlay>
            <FrameBox>
              <DepositStepNewWindow
                src={depositStepIFrame}
                width={depositStepIFrameWidth}
                height={depositStepIFrameHeight}
                setDepositStep={setStep}
                setSpinner={setSpinner}
                requestMethod={depositStepIFrameMethod}
                requestParams={depositStepIFrameParameters}
                formAction={depositStepFormAction}
              />
            </FrameBox>
          </FullPageOverlay>
        )}
      </PageContent>
      <LevelOfProtectionDialog
        showModal={showLevelOfProtectionDialog}
        handleProceed={() => confirmLevelOfProtection()}
        handleCancel={() => cancelLevelOfProtection()}
      />
      <ProfileNotCompleteDialog
        showModal={showProfileNotCompliteDialog}
        //handleProceed={}
      />
      <SetLimitsDialog
        showModal={showSetLimitsDialog}
        handleProceed={() => (window.location = pages["my-limits"])}
        handleCancel={() => setShowSetLimitsDialog(false)}
      />
      {/*{ !isVerified && firstDeposit && (<KYCDialog*/}
      {/*  showModal={true}*/}
      {/*  playerName={player.firstName}*/}
      {/*  serverSetup={server}*/}
      {/*  setSpinner={setSpinner}*/}
      {/*  pages={pages}*/}
      {/*/>*/}
      {/*)}*/}
    </>
  );
};

export default Deposit;
